import { BidiModule } from "@angular/cdk/bidi";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiChipModule } from "../chip/chip.module";
import { UiEmptyModule } from "../empty/empty.module";
import { UiSelectModule } from "../select/select.module";
import { UiTreeModule } from "../tree/tree.module";
import { UiTreeSelectComponent } from "./tree-select.component";

@NgModule({
  imports: [CommonModule, OverlayModule, BidiModule, LocalizationModule, UiButtonModule, UiChipModule, UiTreeModule, UiSelectModule, UiEmptyModule],
  declarations: [UiTreeSelectComponent],
  exports: [UiTreeSelectComponent],
})
export class UiTreeSelectModule {}
